import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import ProductMeasurement from '../../models/ProductMeasurement'

export interface ProductMeasurementListState extends PaginatedApiState {
  productMeasurements?: ProductMeasurement[] 
}

const ProductMeasurementList = (state: ProductMeasurementListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<ProductMeasurementListState>('PRODUCTMEASUREMENT_LIST')(state, action)
  }
}

export default ProductMeasurementList
